import { z } from 'zod';
import { ChannelStates, GroupState, GroupStateValue, SubscriptionChannel } from '../ingest/subscriptions.ts';

export const SubscriptionGroupPurpose = z.enum(['marketing', 'notifications', 'subscriptions']);

export const CreateSubscriptionGroupBody = z.object({
  name: z.string().trim().min(1).max(120),
  channel: SubscriptionChannel,
  purpose: SubscriptionGroupPurpose,
  topic: z.string().trim().min(1).max(120),
  description: z.string().max(500).nullable().optional(),
  defaultState: GroupStateValue.optional(),
  allowClientUpdates: z.boolean().optional(),
});
export type CreateSubscriptionGroupBody = z.infer<typeof CreateSubscriptionGroupBody>;

/** The channel of a group never changes: states recorded for it would mean something else. */
export const UpdateSubscriptionGroupBody = CreateSubscriptionGroupBody.omit({ channel: true }).partial();
export type UpdateSubscriptionGroupBody = z.infer<typeof UpdateSubscriptionGroupBody>;

export const SubscriptionGroupListQuery = z.object({
  status: z.enum(['active', 'archived']).optional(),
  channel: SubscriptionChannel.optional(),
  query: z.string().trim().max(120).optional(),
});
export type SubscriptionGroupListQuery = z.infer<typeof SubscriptionGroupListQuery>;

export const SubscriptionGroupStatsQuery = z.object({ days: z.coerce.number().int().min(1).max(365).default(30) });

export const SetProfileSubscriptionsBody = z.object({
  channels: ChannelStates.optional(),
  groups: z.array(GroupState).max(50).optional(),
  /** Why support changed it (kept in history and audit). */
  reason: z.string().trim().min(3).max(200),
});
export type SetProfileSubscriptionsBody = z.infer<typeof SetProfileSubscriptionsBody>;

/** At most this many active groups per environment (Braze: 450). */
export const MAX_ACTIVE_SUBSCRIPTION_GROUPS = 450;
